import CommonService from '../commonService';

const UploadFileService = new CommonService('bff-file-upload', 'attachment/');
export default UploadFileService;
